import React from "react";

import { Grid, GridSize } from "@mui/material";
import classnames from "classnames";

import useStyles from "../styles";

interface FieldProps {
  label: string;
  value?: string;
  gridSize: GridSize;
  labelClass?: string;
  valueClass?: string;
}

const AccessField = (props: FieldProps) => {
  const { label, value, gridSize, labelClass, valueClass } = props;
  const classes = useStyles();

  return (
    <>
      {value && (
        <Grid item sm={12} lg={gridSize}>
          <div className="d-flex flex-column">
            <label className={classnames(classes.accessInfoLabel, labelClass)}>{label}</label>
            <span className={classnames(classes.accessInfoSpan, valueClass)}>{value}</span>
          </div>
        </Grid>
      )}
    </>
  );
};

export default AccessField;
